import { render, staticRenderFns } from "./EntriesTable.vue?vue&type=template&id=b9d197ea"
import script from "./EntriesTable.vue?vue&type=script&lang=ts"
export * from "./EntriesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports